export default __webpack_public_path__ + "static/media/info_mine.min.ffdd4980.png";